<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="4">
                      <TextBox v-model="item.question" placeholder="Question"
                               :addClass="{'is-invalid': $v.item.question.$error}">Question</TextBox>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label>Quiz</label>
                        <LookUp v-model="selectedQuiz"
                                @search="searchQuiz"
                                placeholder="Please select"
                                :options="quizList"
                                :class="{'is-invalid': $v.selectedQuiz.$error}">
                        </LookUp>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <div v-if="selectedQuiz" class="custom-file custom-file-w-sm mr-2">
                        <input id="addViewChoose" type="file" class="custom-file-input"
                               accept="image/*" @change="onChoose">
                        <label class="custom-file-label border border-light" for="addViewChoose">
                          <span>Upload</span>
                        </label>
                      </div>
                    </b-col>
                    <b-col sm="4">
                      <img v-if="hasImages" style="width: 200px; height: auto;" :src="baseUrl + item.image.imageUrl" alt="img">
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <b-button right type="submit" variant="primary" @click="onSubmit">Save</b-button>
                      <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/question'">Cancel</router-link>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ cartName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse2" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="12">
                      <AnswerTableComponent ref="answerItem"/>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { API_SERVER } from '../../constants/constants'
import AnswerTableComponent from '@/components/AnswerTableComponent'

export default {
  name: 'QuestionAddEditPage',
  data () {
    return {
      item: {},
      selectedQuiz: '',
      quizList: []
    }
  },
  created () {
    if (this.$route.params.quizId && this.$route.params.quizId >= 0) {
      this.$loading.show()
      this.axios.get('quiz/item', {params: {id: this.$route.params.quizId}})
        .then(response => {
          if (response.data.data) {
            this.selectedQuiz = {
              label: response.data.data.title,
              value: response.data.data.id
            }
          }
          this.$loading.hide()
        })
        .catch(error => {
          this.$loading.hide()
          if (error.response && error.response.data.status === 400) {
            this.$toastr.error(error.response.data.message)
          }
        })
    } else if (this.$route.params.id && this.$route.params.id >= 0) {
      this.$loading.show()
      this.axios.get('question/item', {params: {id: this.$route.params.id}})
        .then(response => {
          this.item = response.data.data
          if (this.item.quiz) {
            this.selectedQuiz = {
              label: this.item.quiz.name,
              value: this.item.quiz.id
            }
          }
          this.$refs.answerItem.setItems(this.item.answers)
          this.$loading.hide()
        })
        .catch(error => {
          this.$loading.hide()
          if (error.response && error.response.data.status === 400) {
            this.$toastr.error(error.response.data.message)
          }
        })
    }
  },
  computed: {
    pageName () {
      return this.$route.params.id ? 'Edit Question' : 'Add Question'
    },
    cartName () {
      return this.$route.params.id ? 'Edit Answers' : 'Add Answers'
    },
    hasImages () {
      return this.item.image && this.item.image.imageUrl
    },
    baseUrl () {
      return API_SERVER
    }
  },
  methods: {
    onSubmit () {
      if (this.$v.item.$invalid ||
        this.$v.selectedQuiz.$invalid ||
        this.$refs.answerItem.validate()) {
        this.$refs.answerItem.touch()
        this.$v.$touch()
        this.$toastr.error('Please, fill required fields')
        return
      }
      this.$loading.show()
      this.item.answers = this.$refs.answerItem.getItems()
      this.item.quiz = {id: this.selectedQuiz.value}
      console.log('item: ' + this.item.id)
      let axios
      if (this.item.id) {
        axios = this.axios.put('question/item', this.item)
      } else {
        axios = this.axios.post('question/item', this.item)
      }
      axios.then((res) => {
        this.$loading.hide()
        if (res.data && res.data.status === 200) {
          this.$toastr.success(res.data.message)
          this.$router.push('/question')
        } else {
          this.$toastr.error(res.data.message)
        }
      })
    },
    searchQuiz (search, loading) {
      loading(true)
      this.axios.get('quiz/look-up', {params: {searchKey: search}})
        .then(({data}) => {
          loading(false)
          this.setOptions(data.data)
        }).catch(() => {
          loading(false)
          this.$toastr.error('Internal server error')
        })
    },
    onChoose (event) {
      const formData = new FormData()
      formData.append('file', event.target.files[0])
      formData.append('quizId', this.selectedQuiz.value)
      this.axios.post('question/upload-image', formData,
        {headers: {'Content-Type': 'multipart/form-data'}}
      ).then((response) => {
        if (response.data && response.data.data) {
          const _item = Object.assign({}, this.item)
          _item.image = {
            id: response.data.data.id,
            imageUrl: response.data.data.imageUrl
          }
          this.item = _item
        }
      })
    },
    setOptions (data) {
      const numbItems = []
      data.forEach(function (item) {
        numbItems.push({
          label: item.name,
          value: item.id
        })
      })
      this.quizList = numbItems
    }
  },
  validations: {
    item: {
      question: {
        required
      }
    },
    selectedQuiz: {
      required
    }
  },
  components: {
    AnswerTableComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/question/QuestionAddEditPage.vue